/**
 * 관리자 홈 Container
 * --
 */
import React from 'react';
// import MainHomePresenter from './MainHomePresenter';
import ReviewDashboardContainer from 'routes/admin.routes/admin.dashboard/ReviewDashboard';
import { useUserStack } from 'store';

const ReviewDashboard = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <ReviewDashboardContainer
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          shopType={'SHOP'}
        />
      )}
    </>
  );
};

export default ReviewDashboard;
